
import Vue from 'vue';

import { DocRowData, DisplaySettingsForRendering, ColumnDefs } from '@/pages/search/results/table/table-layout';

export default Vue.component('DocRowDetails', {
	props: {
		row: Object as () => DocRowData,
		cols: Object as () => ColumnDefs,
		info: Object as () => DisplaySettingsForRendering,
		open: Boolean
	},
});
